export default __webpack_public_path__ + "static/media/mainlogo.0698b65c.png";